import { Component, OnInit } from '@angular/core';
import { ErrorAlertComponent } from '../../shared/error-alert/error-alert.component';
import { ReactiveFormsModule, FormsModule, NgForm} from '@angular/forms';
import { LoadingService } from '../../../services/general/loading.service';
import { CommonModule } from '@angular/common';
import { EmailSuppressedInterfaceRequest, EmailSuppressedInterfaceResponse } from '../../../interfaces/getsuppressed-email.interface';
import { SuppressedEmailService } from '../../../services/crc-consult/suppressed-email.service';
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';
import { ResultsModalComponent, ResultField } from '../../shared/results-modal/results-modal.component';


@Component({
  selector: 'app-crc-getsuppressed-email',
  standalone: true,
  imports: [
    ErrorAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ResultsModalComponent
  ],
  templateUrl: './getsuppressed-email.component.html',
  styleUrl: './getsuppressed-email.component.css'
})
export class GetsuppressedEmailComponent implements OnInit {

  showAlertError : boolean = false 
  errorMessage = ''
  emailRequest : EmailSuppressedInterfaceRequest = {
    email : ''
  }
  getSuppressedEmailResponse : EmailSuppressedInterfaceResponse = {
    email : '',
    reason : ''
  }
  token: string = '';
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Consultar lista supresion ses',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  // Modal de resultados
  isModalVisible: boolean = false;
  modalTitle: string = 'Resultados de Consulta';
  modalResults: ResultField[] = [];
  modalHeaderInfo: string = '';

  constructor(
    private _loadingService : LoadingService,
    private _logsService : LogTackingService,
    private _SuppressedEmailService : SuppressedEmailService
  ){}

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') || '';
  }

  onSubmit(form : NgForm){
    this._loadingService.setLoading(true)
    this._SuppressedEmailService.getSuppressedEmails(this.token, this.emailRequest)
      .subscribe({
        next: (response: EmailSuppressedInterfaceResponse) => {
          this.getSuppressedEmailResponse = response
          if(this.getSuppressedEmailResponse.reason == 'BOUNCE'){
            this.getSuppressedEmailResponse.reason = 'BLOQUEADO'
          }else if(this.getSuppressedEmailResponse.reason != 'BOUNCE'){
            this.getSuppressedEmailResponse.reason = 'NO BLOQUEADO'
          }
          
          // Preparar datos para el modal
          this.modalHeaderInfo = `Email consultado: ${this.getSuppressedEmailResponse.email}`;
          this.modalResults = [
            { label: 'CORREO', value: this.getSuppressedEmailResponse.email },
            { label: 'ESTADO', value: this.getSuppressedEmailResponse.reason }
          ];
          this.isModalVisible = true;
          
          this.log_info.details = `Success: Usuario consulto lista de supresion por email ${this.getSuppressedEmailResponse.email}`
          this.createTrackingLog()
          this._loadingService.setLoading(false)
        },
        error: (error: any) => {
          this.errorMessage = error.error.error
          this.log_info.details = `Error: ${this.errorMessage}`
          this.showErrorComponent(form)
        }
      });
  }
  
  cancel(form : NgForm){
    this.getSuppressedEmailResponse = {
      email : '',
      reason: ''
    }
    this.isModalVisible = false;
    this.modalResults = [];
    form.resetForm();
  }
  
  closeModal() {
    this.isModalVisible = false;
  }
  showErrorComponent(form : NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 8000);
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
